<template>
    <div id="nav">
      <div class="pages">
        <div v-for="page in availableMenuItems" :key="page.name" :id="page.name"
          :class="page.meta.children ? 'dropbtn dropdown' :'nodropbtn'">
          <router-link :to="page.slug">
            <span v-if="UserGroup == 'voucherreporting'">
              <h5>{{page.name}}</h5>
            </span>
            <span v-else>
              <h3>{{page.name}}</h3>
            </span>
          </router-link>
            <div v-for="report in page.reports" :key="report.name" class="dropdown-content">
              <div v-if="(report.meta.adminUsers &&  UserGroup == 'voucheradmin') || 
                         (report.meta.pharmacyUsers &&  UserGroup == 'voucherpharmacy') || 
                         (report.meta.reportsUsers &&  UserGroup == 'voucherreporting')">
                <router-link :to="report.slug">
                  <h5>{{report.name}}</h5>
                </router-link>
              </div>
            </div>
        </div>
        <p class='UserName'>Logged in user: <br /> {{userEmail}}</p>
        <div class="notAuthorised" v-if="!authUser">
          <b>
            <p>You are not authorised to use this application.</p>
            <p>Please contact IT support if you require access</p>
          </b>
        </div>

        <div class="notAuthorised" v-if="!UserGroup">
          <b>
            <p>Your session has timed out.</p>
            <p>We are logging you back in</p>
          </b>
        </div>
      </div>
      <div style="clear:both; "></div>
  </div>
</template>

<script>
import store from '@/store'
import UserInfoStore from '@/app/user-info-store';
import auth from '@/app/auth';
import router from '@/router';

export default {
  name: "Menu",
  async created() {
//      console.log("Menu")
      var authGroup = ["voucheradmin","voucherpharmacy", "voucherreporting"]
      if (authGroup.includes(this.UserGroup)){
        this.authUser = true
      }
  },
    
  mounted() {
//    console.log('Mounted ...')
    let firstTime = sessionStorage.getItem('firstTime')
 //   console.log(firstTime)
    if (this.UserGroup == "voucherpharmacy" && firstTime != 'true') {  // auto open vaccination page for pharmacies
      router.push({name: 'Vaccination'});
      sessionStorage.setItem('firstTime', 'true')
    }
//    console.log('Mounted end')
  },

  data() {
    return {
      pages: store.pages,
      UserGroup: UserInfoStore.state.userGroup.toLowerCase(),  // make user group checking case insensitive
      UserBranch: UserInfoStore.state.branchName,
      userEmail: UserInfoStore.state.userEmail.toLowerCase(),
      authUser: false,
    }
  },
  computed:{
    availableMenuItems() {
//      console.log(this.UserGroup)
      let tempMenu = this.pages;
      if (!this.UserGroup){
        this.unauthDelay();
        }
      tempMenu = tempMenu.filter((item) => {
        if (this.UserGroup === 'voucheradmin') {
          return (item.meta.adminUsers)
        }
        else if (this.UserGroup === 'voucherpharmacy') {
          return (item.meta.pharmacyUsers)
        }
        else if (this.UserGroup === 'voucherreporting') {
          return (item.meta.reportsUsers)
        }
        else {
          return null
        }
      })
      return tempMenu
    },
  },
  methods: {
    unauthDelay() {
  //    console.log("unauthDelay")
      setTimeout( () =>{
        auth.userLogout()
        }, 3000)
      
    }
  }
};

</script>
